import React from 'react';
import Card from './Card';
import { Box } from '@mui/material';
import LinkButton from '../../components/LinkButton';
import CostSection from './CostSection';
import useIncentives from './hooks/useIncentives';

export default function Incentives({ myProject, incentives, onClickIncentivePrompt }) {
  const { incentivesAreReady, incentivesAsCosts } = useIncentives({ myProject, incentives });

  return (
    <Card>
      {!incentivesAreReady && (
        <Box mb={3}>
          <CostSection label="Available Incentives" direction="down" costs={[]}>
            <LinkButton sx={{ fontWeight: '700' }} onClick={onClickIncentivePrompt}>
              Click to see available incentives for you
            </LinkButton>
          </CostSection>
        </Box>
      )}

      {incentivesAreReady && (
        <Box mb={3}>
          <CostSection
            label={
              <>
                Available Incentives{' '}
                <LinkButton
                  sx={{
                    textTransform: 'uppercase',
                    fontWeight: '700',
                    fontSize: '8pt',
                  }}
                  onClick={onClickIncentivePrompt}
                >
                  Edit
                </LinkButton>
              </>
            }
            direction="down"
            costs={incentivesAsCosts}
          >
            {incentivesAsCosts.length === 0 &&
              'Based on your zip code and income, no rebates are currently available. Check back as new programs are added.'}
          </CostSection>
        </Box>
      )}
    </Card>
  );
}
